export default "__VITE_ASSET__Djm3AJoK__"